import axios from 'axios'

// eslint-disable-next-line
export let HTTP = new axios.create({
    baseURL: process.env.BASE_URL,
    withCredentials: true,
    headers: {
        'Authorization': 'Basic'
    }
})

export let HTTPGCS = new axios.create({
    baseURL: process.env.BASE_URL
})



// WEBPACK FOOTER //
// ./src/assets/js/axiosConfig.js